<template>
  <div style="width: 800px;">
    <canvas id="index-values-chart"></canvas>
  </div>
</template>

<script>
import Chart from 'chart.js/auto'

let chart

export default {
  props: {
    monthlyIndexValues: {
      type: Array,
      required: true,
    },
  },
  computed: {
    sortedMonthlyIndexValues() {
      return [...this.monthlyIndexValues].sort(
        (v1, v2) => (v1.year - v2.year) * 12 + (v1.month - v2.month),
      )
    },
    chartData() {
      return {
        data: {
          labels: this.sortedMonthlyIndexValues.map(
            (v) => `${v.year}-${v.month}`,
          ),
          datasets: [
            {
              type: 'line',
              label: 'Index',
              data: this.sortedMonthlyIndexValues.map((v) => v.value),
              fill: false,
              borderColor: '#c87832',
              backgroundColor: '#c87832',
              tension: 0.1,
              yAxisID: 'y',
              pointRadius: 0,
            },
            {
              type: 'bar',
              label: 'Variation (%)',
              data: this.sortedMonthlyIndexValues.map(
                (v) => v.periodVariation * 100.0,
              ),
              borderColor: '#808080',
              backgroundColor: '#808080',
              yAxisID: 'y1',
            },
          ],
        },
        options: {
          responsive: true,
          stacked: false,
          interaction: {
            intersect: false,
          },
          scales: {
            y: {
              type: 'linear',
              display: true,
              position: 'left',
            },
            y1: {
              type: 'linear',
              display: true,
              position: 'right',
            },
          },
        },
      }
    },
  },
  mounted() {
    const ctx = document.getElementById('index-values-chart')
    chart = new Chart(ctx, this.chartData)
  },
  watch: {
    monthlyIndexValues() {
      chart.data = this.chartData.data
      chart.update()
    },
  },
}
</script>
